module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9639.6b442a37.jpg";